"use strict";
/*
TODO: Update
These are fetched from a db table we will need to
decide whether to  map these to ids or fetch from the table itself
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustLabels = exports.Trust = exports.CountyLabel = exports.County = exports.HowYouHeardLabels = exports.HowYouHeard = exports.TypeLabels = exports.Type = exports.Gender = exports.Title = void 0;
var Title;
(function (Title) {
    Title["Mrs"] = "Mrs";
    Title["Miss"] = "Miss";
    Title["Ms"] = "Ms";
    Title["Mr"] = "Mr";
    Title["Captain"] = "Captain";
    Title["Doctor"] = "Doctor";
    Title["Father"] = "Father";
    Title["HRH"] = "HRH";
    Title["Lady"] = "Lady";
    Title["Lord"] = "Lord";
    Title["Professor"] = "Professor";
    Title["Rev"] = "Rev";
    Title["Sir"] = "Sir";
    Title["Sister"] = "Sister";
})(Title = exports.Title || (exports.Title = {}));
var Gender;
(function (Gender) {
    Gender["Female"] = "1";
    Gender["Male"] = "2";
})(Gender = exports.Gender || (exports.Gender = {}));
var Type;
(function (Type) {
    Type[Type["ActionCancerEvent"] = 14] = "ActionCancerEvent";
    Type[Type["ActionCancerHouse"] = 17] = "ActionCancerHouse";
    Type[Type["ActionCancerShop"] = 21] = "ActionCancerShop";
    Type[Type["App"] = 9] = "App";
    Type[Type["BigBus"] = 6] = "BigBus";
    Type[Type["Facebook"] = 19] = "Facebook";
    Type[Type["FamilyHistoryClinic"] = 25] = "FamilyHistoryClinic";
    Type[Type["FlagDay"] = 12] = "FlagDay";
    Type[Type["Flyer"] = 11] = "Flyer";
    Type[Type["GeneticReferral"] = 24] = "GeneticReferral";
    Type[Type["GeneticsClinic"] = 26] = "GeneticsClinic";
    Type[Type["GordonsChemist"] = 10] = "GordonsChemist";
    Type[Type["HealthProfessional"] = 22] = "HealthProfessional";
    Type[Type["Letter"] = 7] = "Letter";
    Type[Type["Newspaper"] = 3] = "Newspaper";
    Type[Type["Outdoorposter"] = 16] = "Outdoorposter";
    Type[Type["RadioAdvert"] = 2] = "RadioAdvert";
    Type[Type["RadioInterview"] = 15] = "RadioInterview";
    Type[Type["Supervalu"] = 23] = "Supervalu";
    Type[Type["talkSPORT"] = 20] = "talkSPORT";
    Type[Type["TSletter"] = 8] = "TSletter";
    Type[Type["Through organisation"] = 13] = "Through organisation";
    Type[Type["TV"] = 1] = "TV";
    Type[Type["Website"] = 4] = "Website";
    Type[Type["WordofMouth"] = 5] = "WordofMouth";
    Type[Type["Other"] = 18] = "Other";
})(Type = exports.Type || (exports.Type = {}));
exports.TypeLabels = {
    14: "Action Cancer Event",
    17: "Action Cancer House",
    21: "Action Cancer Shop",
    9: "App",
    6: "Big Bus",
    19: "Facebook",
    25: "Family History Clinic",
    12: "Flag Day",
    11: "Flyer",
    24: "Genetic Referral",
    26: "Genetics Clinic",
    10: "Gordon's Chemist",
    22: "Health Professional",
    7: "Letter",
    3: "Newspaper",
    16: "Outdoor poster",
    2: "Radio Advert",
    15: "Radio Interview",
    23: "Supervalu",
    20: "talkSPORT",
    8: "T/S letter",
    13: "Through organisation",
    1: "TV",
    4: "Website",
    5: "Word of Mouth",
    18: "Other",
};
var HowYouHeard;
(function (HowYouHeard) {
    HowYouHeard[HowYouHeard["DiagnosedWithCancer"] = 1] = "DiagnosedWithCancer";
    HowYouHeard[HowYouHeard["Family"] = 2] = "Family";
    HowYouHeard[HowYouHeard["Friend"] = 3] = "Friend";
    HowYouHeard[HowYouHeard["Carer"] = 4] = "Carer";
})(HowYouHeard = exports.HowYouHeard || (exports.HowYouHeard = {}));
exports.HowYouHeardLabels = {
    1: "Diagnosed with cancer",
    2: "Family",
    3: "Friend",
    4: "Carer",
};
var County;
(function (County) {
    County[County["Antrim"] = 2] = "Antrim";
    County[County["Armagh"] = 3] = "Armagh";
    County[County["Down"] = 9] = "Down";
    County[County["Fermanagh"] = 11] = "Fermanagh";
    County[County["Derry"] = 19] = "Derry";
    County[County["Tyrone"] = 29] = "Tyrone";
})(County = exports.County || (exports.County = {}));
exports.CountyLabel = {
    2: "Antrim",
    3: "Armagh",
    9: "Down",
    11: "Fermanagh",
    19: "Derry / Londonderry",
    29: "Tyrone",
};
var Trust;
(function (Trust) {
    Trust[Trust["NHSCT"] = 1] = "NHSCT";
    Trust[Trust["BHSCT"] = 2] = "BHSCT";
    Trust[Trust["SEHSCT"] = 3] = "SEHSCT";
    Trust[Trust["SHSCT"] = 4] = "SHSCT";
    Trust[Trust["WHSCT"] = 5] = "WHSCT";
})(Trust = exports.Trust || (exports.Trust = {}));
exports.TrustLabels = {
    1: "Northern - NHSCT",
    2: "Belfast - BHSCT",
    3: "South Eastern - SEHSCT",
    4: "Southern - SHSCT",
    5: "Western - WHSCT",
};
//# sourceMappingURL=User.js.map